import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { LocalComponentStore } from "@dtm-frontend/shared/utils";

interface News11ComponentState {
    activeLanguage: string | undefined;
}

@Component({
    selector: "dtm-main-page-lib-news-11",
    templateUrl: "./news-11.component.html",
    styleUrls: ["./news-11.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [LocalComponentStore],
})
export class News11Component {
    @Input() public set activeLanguage(value: string | undefined) {
        this.localStore.patchState({ activeLanguage: value });
    }

    protected readonly activeLanguage$ = this.localStore.selectByKey("activeLanguage");

    constructor(private readonly localStore: LocalComponentStore<News11ComponentState>) {
        localStore.setState({ activeLanguage: undefined });
    }
}
